import React, { useEffect } from "react";
import "./Sidebar.css";
import { Link, useNavigate } from "react-router-dom";
import { Cog, ScanSearch, CircleHelp } from "lucide-react";

import TravelAgency from "../../assets/travel-agency.svg";
import Home from "../../assets/home.svg";
import EmAndamento from "../../assets/em-andamento.svg";
import Cancel from "../../assets/cancel.svg";

const SidebarLandingPage = ({
  menuOpen,
  setMenuOpen,
  handleSearchClick,
  handleStorage,
}) => {
  const navigate = useNavigate();
  const handleCloseMenu = () => setMenuOpen(false);

  useEffect(() => {
    if (menuOpen) {
      document.documentElement.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = "auto";
      document.body.style.overflow = "unset";
    }

    return () => {
      document.documentElement.style.overflow = "auto";
      document.body.style.overflow = "unset";
    };
  }, [menuOpen]);

  return (
    <>
      <div
        className={`mobile-overlay ${menuOpen ? "show" : ""}`}
        onClick={handleCloseMenu}
      />

      <aside className={`sidebar ${menuOpen ? "open" : "closed"}`}>
        <button
          className="desktop-toggle"
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          {menuOpen ? "❮" : "❯"}
        </button>

        <nav>
          <ul>
            <li
              className="active"
              onClick={() => {
                handleCloseMenu();
                navigate("/como-funciona");
              }}
            >
              <Cog size={30} />
              Como funciona
            </li>

            <li
              onClick={(e) => {
                handleCloseMenu();
                handleSearchClick(e);
              }}
            >
              <ScanSearch size={30} />
              Procurar mala
            </li>

            <li onClick={handleStorage}>
              <img src={TravelAgency} className="sidebar-icon" alt="" />
              Oferecer mala
            </li>

            <li
              onClick={() => {
                handleCloseMenu();
                navigate("/perguntas-frequentes");
              }}
            >
              <CircleHelp size={30} />
              FAQ
            </li>
          </ul>
        </nav>
      </aside>
    </>
  );
};

export default SidebarLandingPage;
